import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getScheduledOrderingParentFeatureFlag,
  getScheduledOrderingGCOFeatureFlag,
} from 'shared/app/utils/feature-flags';

import { scheduledOrderingEnabledSelector } from 'shared/app/state/selectors/ordering';
import { signedInSelector } from 'shared/app/bundles/user';

import { SET_SHOULD_SHOW_SCHEDULED_ORDERING } from 'shared/app/state/action-creators/types';

export const useScheduledOrdering = () => {
  const dispatch = useDispatch();
  const [flags, setFlags] = useState({
    isScheduledOrderingEnabled: false,
    isScheduledOrderingGCOEnabled: false,
  });
  const [scheduledOrderingLoading, setScheduledOrderingLoading] =
    useState(false);
  const [shouldShowScheduledOrdering, setShowScheduledOrdering] =
    useState(false);

  const userSignedIn = useSelector(signedInSelector);
  const scheduledOrderingLocaleSupported = useSelector(
    scheduledOrderingEnabledSelector
  );

  const fetchScheduledOrderingFeatureFlags = async () => {
    setScheduledOrderingLoading(true);
    const [parentFlag, gcoFlag] = await Promise.all([
      getScheduledOrderingParentFeatureFlag(),
      getScheduledOrderingGCOFeatureFlag(),
    ]);

    setFlags({
      isScheduledOrderingEnabled: parentFlag,
      isScheduledOrderingGCOEnabled: gcoFlag,
    });
    setScheduledOrderingLoading(false);
  };

  useEffect(() => {
    fetchScheduledOrderingFeatureFlags();
  }, []);

  useEffect(() => {
    if (flags.isScheduledOrderingEnabled && scheduledOrderingLocaleSupported) {
      if (flags.isScheduledOrderingGCOEnabled || userSignedIn) {
        setShowScheduledOrdering(true);
      } else {
        setShowScheduledOrdering(false);
      }
    }
  }, [flags]);

  useEffect(() => {
    dispatch({
      type: SET_SHOULD_SHOW_SCHEDULED_ORDERING,
      payload: shouldShowScheduledOrdering,
    });
  }, [shouldShowScheduledOrdering]);

  return { scheduledOrderingLoading, shouldShowScheduledOrdering };
};
